// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rwNvu","header":"styles_header__9FCmj","footer":"styles_footer__wMozj","backdrop":"styles_backdrop__PnfAj","innerModal":"styles_innerModal__z6bMT"};